interface EditorReadOnlyImageProps {
  img: string;
}

const EditorReadOnlyImage: React.FC<EditorReadOnlyImageProps> = ({ img }) => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
    <div style={{ position: "relative", display: "inline-block" }}>
      <img
        src={img.startsWith("data:image") ? img : `data:image/png;base64,${img}`}
        alt="Imagen generada"
        style={{
          maxWidth: "100%",
          maxHeight: "80vh",
          borderRadius: "8px",
          filter: "grayscale(20%)",
          pointerEvents: "none",
          userSelect: "none",
          display: "block",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(200,200,200,0.7)",
          borderRadius: "8px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          pointerEvents: "none",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              fontSize: "1rem",
              color: "#555",
              fontWeight: "500",
              fontFamily: "Montserrat",
            }}
          >
            Elemento no editable
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default EditorReadOnlyImage;
